export const WAIT_STATE = {
  WAITING_ARRIVAL: 'waiting_arrival',
  MANUAL_ARRIVAL: 'manual_arrival',
  BEFORE_SCHEDULE: 'before_schedule',
  WAITING: 'waiting',
  STARTED: 'started',
  BLOCKED_BY_MV: 'blocked_by_mv',
  ORDER_ADDED: 'order_added',
  SECOND_TRIP: 'second_trip',
  DISCARDED_WAIT: 'discarded_wait'
}

export const SUMMARY_TITLES = {
  waiting: 'Esperando',
  exceeded: 'Excedidas',
  departed: 'Salieron'
}

export const REFRESH_INTERVAL_MS = 30000

export const LOCAL_TICK_MS = 1000

export const MILLISECONDS_PER_SECOND = 1000
